export const messages = {
    'otpModal.header': 'Request an OTP',
    'otpModal.otp': 'This is your OTP:',
    'otpModal.expiration': 'This OTP expires in: ',
    'otpModal.button.revoke': 'Revoke OTP',
    'otpModal.button.close': 'Close',
    'otpModal.button.refreshOtp': 'Refresh OTP',
}
